export default __webpack_public_path__ + "static/media/H1006.2.cd6067ea.mp3";